<template lang="pug">
	.split-container
		.form-container
			.columns.is-centered.is-vcentered.is-multiline.is-mobile
				.column
					.field
						p.control.has-icons-left
							input.input(
								ref="inputCode"
								type="text"
								:placeholder="$t('placeholder.promo_code')"
								maxlength="16"
								v-model="promo_code"
								v-on:keyup.enter="submitPromoCode")
							span.icon.is-small.is-left
								gift-icon(size="1.5x")
				.column.is-narrow
					.field
						p.control.has-text-centered
							button.button.is-primary(type="button" @click="submitPromoCode")
								| {{ $t('button.submit') }}

			article.message.is-danger(v-if="missingCode" transition="fade")
				.message-body
					| {{ $t('alert.missing_promo_code') }}
			article.message.is-danger(v-if="invalidCode" transition="fade")
				.message-body
					| {{ $t('alert.invalid_promo_code') }}
			article.message.is-danger(v-else-if="expiredCode" transition="fade")
				.message-body
					| {{ $t('alert.expired_promo_code') }}
			article.message.is-danger(v-else-if="errorPage" transition="fade")
				.message-body
					| {{ $t('alert.generic_error') }}
</template>

<script>
import { GiftIcon } from 'vue-feather-icons'

export default {
	components: {
		GiftIcon
	},
	data() {
		return {
			promo_code       : '',
			missingCode      : false,
			expiredCode      : false,
			invalidCode      : false,
			errorPage        : false,
			loadingPromoCode : false
		}
	},
	computed: {
		accessToken() {
			return this.$store.state.auth.accessToken
		},
		userState() {
			return this.$store.state.user.userState
		}
	},
	methods: {
		submitPromoCode() {
			if (!this.promo_code) {
				this.missingCode = true
				this.$refs.inputCode.focus()
				return
			}
			if (this.loadingPromoCode) return

			this.$emit('onload')
			this.loadingPromoCode = true
			this.$store.dispatch('user/submitPromoCode', {
				'token': this.accessToken,
				'code':  this.promo_code
			}).then(res => {
				this.invalidCode = false
				this.expiredCode = false
				return this.$alert(this.$t('alert.valid_promo_code'), null, 'success');
			}).then(() => {
				this.loadingPromoCode = false
				this.$emit('onloaded')
			}).catch(err => {
				this.loadingPromoCode = false
				this.$emit('onloaded')
				if (err.response && err.response.status) {
					switch (err.response.status) {
						case 404:
							if (err.response.data) console.log(err.response.data)
							if (err.response.data && err.response.data.error_message === 'Expired Code') {
								this.expiredCode = true
							} else {
								this.invalidCode = true
							}
							break
						case 500:
							this.errorPage = true
							break
						default:
							console.warn(err.response.status)
					}
				}
			})
		}
	},
	watch: {
		promo_code() {
			this.missingCode = false
			this.invalidCode = false
			this.expiredCode = false
		}
	}
}
</script>
